import React, {useState} from 'react'

export const AddCategory = (props) => {

    const {handleAddElement} = props;
    const [search, setSearch] = useState("");

    const handleChange = (e) => {
        setSearch(e.target.value);
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        // Validate
        handleAddElement(search.toLocaleLowerCase());
        setSearch("");
    }
    return (
        <form onSubmit = {handleSubmit}>
            <input type = "text" value = {search} onChange = {handleChange} placeholder="Search..." /> 
        </form>
    )
}
